/**
 * WEB-3737 — корень кабинета нового вида: атрибуты, под которыми действует
 * таблица токенов `styles/cabinet-tokens.css` (отступы, радиусы, кегли, цвета
 * обеих тем, плотность, вид «как лендинг» — значения из эталона
 * `design/cabinet-rescin/kit.jsx` спек-репо).
 *
 * Тема корня — тот же механизм, что у всего кабинета (`useResolvedTheme`):
 * выбор человека → сохранённый выбор → тема устройства. Плотный вид и вид «как
 * лендинг» — постоянные: оболочка эталона ставит их всегда
 * (`data-density="compact" data-look="landing"`, `app.jsx`; переключатели
 * «Плотность» и «Вид» сняты владельцем 20.10).
 *
 * Токены вне элемента с этими атрибутами не действуют: файл токенов задаёт
 * переменные только под `.ds` и подключается двумя дверьми — входом кабинета
 * `main.tsx` и каркасом страниц покупателя `components/public/buyer/BuyerPage.tsx`
 * (ленивый кусок публичного входа, WEB-3826; сторож — `cabinetTokens.test.ts`).
 */
import type { UserTheme } from '@/types';
import type { ResolvedTheme } from './antdTheme';
import { useResolvedTheme } from './useResolvedTheme';

/** Класс корня кабинета нового вида — как в эталоне. */
export const CABINET_ROOT_CLASS = 'ds';

export interface CabinetRootAttributes {
  className: typeof CABINET_ROOT_CLASS;
  'data-theme': ResolvedTheme;
  'data-density': 'compact';
  'data-look': 'landing';
}

/** Атрибуты корня `.ds` для разрешённой темы. */
export function cabinetRootAttributes(
  theme: ResolvedTheme,
): CabinetRootAttributes {
  return {
    className: CABINET_ROOT_CLASS,
    'data-theme': theme,
    'data-density': 'compact',
    'data-look': 'landing',
  };
}

/** Атрибуты корня `.ds` по выбору темы человека (через `useResolvedTheme`). */
export function useCabinetRootAttributes(
  userTheme: UserTheme | undefined,
): CabinetRootAttributes {
  return cabinetRootAttributes(useResolvedTheme(userTheme));
}
